import startCase from "lodash/startCase";
import { InternalAccountType } from "@wingspanhq/wingspan-api-sdk";

export const accountTypeToHumanReadable = (
  accountType: InternalAccountType | `${InternalAccountType}`
) => {
  switch (accountType) {
    case "Banking":
      return "Wingspan Wallet";
    case "Clearing":
      return "Clearing";
    case "TaxWithholding":
      return "Tax Withholding";
    case "CardClearing":
      return "Card Clearing";
    case "InternationalClearing":
      return "International Clearing";
    default:
      return startCase(accountType);
  }
};
